import { IStatement, VerbIds, ActivityTypes } from "./xAPIInterfaces";
import URLHelper from "../URLHelper";

// tslint:disable-next-line:variable-name
const TinCan = require("tincanjs");

namespace xApiHelper {
    export function initLRS(endpoint, username, password, allowFail = false): void {
        if (lrsObj.lrs === undefined) {
            try {
                const lrs = new TinCan.LRS({
                    endpoint: endpoint,
                    username: username,
                    password: password,
                    allowFail: allowFail
                });
                lrsObj.lrs = lrs;
            } catch (ex) {
                console.log("Failed to setup LRS object: ", ex);
                // TODO: do something with error, can't communicate with LRS
            }
        }
    }
    export let lrsObj: any = {};
    // try {
    //     const lrs = new TinCan.LRS({
    //         endpoint: "https://etswrapper.lrs.io/xapi/",
    //         username: "ppl-xapi",
    //         password: "ppl-xapi",
    //         allowFail: false
    //     });
    //     lrsObj.lrs = lrs;
    // } catch (ex) {
    //     console.log("Failed to setup LRS object: ", ex);
    //     // TODO: do something with error, can't communicate with LRS
    // }

    export async function sendLogs(): Promise<void> {
        this.initialize();
        await this.sendStatement();
    }

    // xApiHelper.sendStatement({
    //     actor: {
    //         mbox: "",
    //         objectType: "Agent"
    //     },
    //     verb: {
    //         id: VerbIds.ACTIVATED,
    //         display: ""
    //     },
    //     object: {
    //         id: ActivityTypes.AREA
    //     }
    // });

    export async function statementMaker(statement: IStatement): Promise<void> {
        let defaultEmailId = "test@playpowerlabs.com";
        let defaultStatement: IStatement = {
            actor: {
                mbox: localStorage.getItem("credentials") || defaultEmailId,
                name: "testing",
                objectType: "Agent"
            },
            verb: {
                id: VerbIds.FILLEDOUT,
                display: { "en-US": "filling default values" }
            },
            object: {
                id: ActivityTypes.TEST_DATA_BATCH
            }
        };
        let finalStatement: IStatement = Object.assign(defaultStatement, statement);
        if (URLHelper.getUrlParams()["mode"] !== "dev") {
            await this.sendStatement(finalStatement);
        }
    }

    export async function sendStatement(statement: IStatement): Promise<void> {
        let statementToSend = new TinCan.Statement(statement);
        if (lrsObj.lrs !== undefined) {
            lrsObj.lrs.saveStatement(
                statementToSend,
                {
                    callback: (err, xhr) => {
                        if (err !== null) {
                            if (xhr !== null) {
                                console.log("Failed to save statement: " + xhr.responseText + " (" + xhr.status + ")");
                                return;
                            }
                            console.log("Failed to save statement: " + err);
                            // TODO: do something with error, didn't save statement
                            return;
                        }
                        console.log("Statement saved");
                        // TOOO: do something with success (possibly ignore)
                    }
                }
            );
        }
    }
}
export default xApiHelper;
